export const getStoreSettings = () => {
  var _window$swag$storeSet, _window, _window$swag;
  return (_window$swag$storeSet = (_window = window) === null || _window === void 0 ? void 0 : (_window$swag = _window.swag) === null || _window$swag === void 0 ? void 0 : _window$swag.storeSettings) !== null && _window$swag$storeSet !== void 0 ? _window$swag$storeSet : {};
};